(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-redirect', actionFunc);

    function actionFunc(Path, lodash, $q, $location) {

        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function (options, eventData, actionData) {
            // Todo: Need to confirm if eventData is exactly eventData (as in arguments[1], or arguments[2]);
            return $q.when(run());
            function run() {
                if (!lodash.has(options, 'destination')) {
                    return false;
                }

                let postData = eventData;
                if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                    postData = actionData;
                }

                let endpoint = decodeURI(options.destination).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(postData, submatch, '');
                });


	        	var searchData = lodash.get(options, 'searchData', {});
                if ((!!lodash.get(options, 'setFieldsAsParams', false)) === true) {
                    searchData = lodash.merge(searchData, postData);
                }

                if ((!!lodash.get(options, 'paramsExclude', false)) === true) {
                    searchData = lodash.omit(searchData, options.paramsExclude)
                }

                switch (options.target) {
                    case 'newTab': {
                        Path.newTab(endpoint);
                        break;
                    }
                    case 'newWindow': {
                        var title = lodash.get(options, 'title', null);
                        var config = lodash.get(options, 'config', null);
                        if (options.centre === true) {
                            var w = parseInt(lodash.get(config, 'width', 480));
                            var h = parseInt(lodash.get(config, 'height', 600));
                            var y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
                            var x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
                            config.top = y;
                            config.left = x;
                        }
                        var config_str = lodash.map(config, function(value, key) {
                            return key + '=' + value;
                        }).join(',');
                        Path.newWindow(endpoint, title, config_str);
                        break;
                    }
                    case 'reload': {
                        Path.reload(endpoint);
                        break;
                    }
                    default: {
                        Path.redirect(endpoint, searchData);
                        break;
                    }
                }

                return true;
            }
        };
    }
})();

